import { render, staticRenderFns } from "./accounts-receivable-settlement.vue?vue&type=template&id=2b68db58&"
import script from "./accounts-receivable-settlement.vue?vue&type=script&lang=js&"
export * from "./accounts-receivable-settlement.vue?vue&type=script&lang=js&"
import style0 from "./accounts-receivable-settlement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports